import styled from "styled-components";
import { colors } from "@literati/public-ui-shared-react";

export const PaymentSectionCard = styled.section`
  display: flex;
  align-items: center;
  background: ${colors.white};
  border-radius: 12px;
  padding: 1.25rem;
`;

export const PaymentParagraph = styled.p`
  font-size: 0.875rem;

  span {
    font-weight: 700;
  }
`;

export const PaymentSectionCardHeader = styled.h2`
  font-size: 0.875rem;
  font-weight: 700;
`;
